import React, { useEffect, useMemo, useRef } from "react";

import { Disclosure } from "@headlessui/react";

import bigArrow from "@assets/image/icones/BigArrow.svg";

const LitleDisclosure = (props) => {
  const {
    elementTitle,
    childrenTitle,
    title,
    titleIcon,
    children,
    defaultOpen,
    spaceTitle,
    classSpaceTitle,
    classParent,
    innerRef,
    autoClose,
    // autoCloseRef,
    customArrow,
    customArrowShape,
    LitleTitle,
    customPadding = "arh-pb-[0.695rem] arh-pt-[0.775rem]"
  } = props;

  const localRef = useRef(null);

  const litleDisclosureRef = useMemo(() => innerRef || localRef, [innerRef, localRef])

  const handleClickOutside = (event) => {
    // if (autoCloseRef.current && !autoCloseRef.current.contains(event.target)) {
    //   const button = autoCloseRef.current.querySelector('[aria-expanded]');
    if (autoClose && litleDisclosureRef?.current && !litleDisclosureRef.current.contains(event.target)) {
      const button = litleDisclosureRef.current.querySelector('[aria-expanded]');
      if (button && button.getAttribute('aria-expanded') === 'true') {
        button.click();
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div
      className={classParent + " arh-w-full "}
      // ref={innerRef || autoCloseRef}
      ref={litleDisclosureRef}
    >
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button
              className={`arh-flex arh-w-full arh-border-none arh-items-center arh-justify-between arh-bg-transparent arh-px-4 ${customPadding}  arh-text-left`}
            >
              {LitleTitle ? (
                <label className="arh-mb-1 arh-flex arh-items-center arh-font-poppins arh-text-xs arh-font-medium arh-text-black  ">
                  {titleIcon}
                  <span className={spaceTitle ? classSpaceTitle : "arh-ml-12"}>
                    {title}
                  </span>
                  {elementTitle ? childrenTitle : ""}
                </label>
              ) : (
                <h6 className="arh-m-0 arh-flex  arh-items-center arh-font-poppins arh-text-[0.938rem] arh-font-bold arh-text-darkColor">
                  {titleIcon}
                  <span className={spaceTitle ? classSpaceTitle : "arh-ml-12"}>
                    {title}
                  </span>
                  {elementTitle ? childrenTitle : ""}
                </h6>
              )}
              <img
                src={customArrow ? customArrowShape : bigArrow}
                alt="Arrow icon"
                className={`${open
                  ? "arh-rotate-90 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
                  : "arh-rotate-0 arh-transform arh-transition arh-duration-[100ms] arh-ease-in"
                  }`}
              />
            </Disclosure.Button>

            <Disclosure.Panel unmount={false}>{children}</Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
};

export default LitleDisclosure;
